<template>
  <hel-module title="企业战情室" :class="scope.clsPrefix">
    <template slot="extra">
      <span class="card-tag chat-tag" @click.stop="toggleChatInput">
        <i class="el-icon-plus"></i>
      </span>
      <span class="card-tag" @click.stop="handleOpenList">全部</span>
    </template>
    <template v-if="displayCards.length > 0">
      <div class="cards-row">
        <div
          v-for="(card, idx) in displayCards"
          :key="idx"
          class="card-content"
          @click="handleOpenDetail(card)"
        >
          <!-- <div class="card-type-tag">{{ card.typeLabel }}</div> -->
          <div class="content-section">
            <div class="section-header">
              <span class="war-section-title">{{ card.title }}</span>
            </div>
            <div class="section-desc">{{ card.desc }}</div>
          </div>
          <div class="action-buttons">
            <button
              v-for="(btn, bidx) in card.tags"
              :key="bidx"
              class="btn-secondary"
            >
              {{ btn }}
            </button>
          </div>
          <div class="footer-btn">
            <span class="card-tag detail-tag" @click.stop="handleOpenDetail(card)">详情</span>
            <div class="btn-primary" @click.stop="handleSmartAnalysis(card)">智能分析</div>
          </div>
        </div>
      </div>
    </template>
    <div v-else class="card-empty">暂无数据</div>

    <!-- 下拉 CosmoClawInput -->
    <transition name="chat-fade">
      <div v-if="chatVisible" class="chat-dropdown">
        <div class="chat-dropdown-inner">
          <div class="chat-dropdown-header">
            <span>向智能体提问</span>
            <i class="el-icon-close" @click="chatVisible = false"></i>
          </div>
          <CosmoClawInput ref="input" force-enable />
        </div>
      </div>
    </transition>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import CosmoClawInput from '../../smart-workbench/components/CosmoClawInput.vue'
import { getJobReportPageApi } from '@/api/agentAuth'

export default {
  name: 'EnterpriseWarRoom',
  components: {
    HelModule,
    CosmoClawInput
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    agentId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-enterprise-war-room'
      },
      businessItems: [],
      newsItems: [],
      chatVisible: false
    }
  },
  computed: {
    displayCards() {
      const cards = []
      const biz = this.businessItems
      const news = this.newsItems
      // 优先 1 经营 + 1 资讯，其次 2 经营，最后 2 资讯
      if (biz.length > 0 && news.length > 0) {
        cards.push(this.buildCard(biz[0], '经营简报'))
        cards.push(this.buildCard(news[0], '资讯简报'))
      } else if (biz.length > 0) {
        cards.push(this.buildCard(biz[0], '经营简报'))
        if (biz.length > 1) cards.push(this.buildCard(biz[1], '经营简报'))
      } else if (news.length > 0) {
        cards.push(this.buildCard(news[0], '资讯简报'))
        if (news.length > 1) cards.push(this.buildCard(news[1], '资讯简报'))
      }
      return cards
    }
  },
  mounted() {
    this.fetchReports()
  },
  watch: {
    // 发送后自动关闭下拉
    chatVisible(val) {
      if (val) {
        this._savedSessionKey = this.$store.state.cosmoClaw.currentSessionKey
        this._msgCleared = false
        this.$store.commit('cosmoClaw/SET_CURRENT_SESSION_KEY', null)
      } else if (this._savedSessionKey) {
        this.$store.commit('cosmoClaw/SET_CURRENT_SESSION_KEY', this._savedSessionKey)
        this._savedSessionKey = null
      }
    },
    // createNewSession 先清空消息(N→0)，sendMessage 再加一条(0→1)
    '$store.state.cosmoClaw.messages'(msgs) {
      if (!this.chatVisible) return
      if (msgs.length === 0) {
        this._msgCleared = true
      } else if (this._msgCleared && msgs[msgs.length - 1]?.type === 'user') {
        this._msgCleared = false
        this._savedSessionKey = null
        this.chatVisible = false
      }
    }
  },
  methods: {
    buildCard(item, typeLabel) {
      return {
        item,
        typeLabel,
        title: item.title || typeLabel,
        desc: item.content || item.summary || item.title || '',
        tags: item.tags ? item.tags.split(',').slice(0, 2) : []
      }
    },
    async fetchReports() {
      try {
        const [bizRes, newsRes] = await Promise.all([
          getJobReportPageApi({ agentId: this.agentId, category: 'internal', page: 1, size: 2 }),
          getJobReportPageApi({ agentId: this.agentId, category: 'external', page: 1, size: 2 })
        ])
        this.businessItems = (bizRes && bizRes.data && bizRes.data.records) ? bizRes.data.records : []
        this.newsItems = (newsRes && newsRes.data && newsRes.data.records) ? newsRes.data.records : []
      } catch (error) {
        console.error('获取战情室报告失败:', error)
        this.businessItems = []
        this.newsItems = []
      }
    },
    handleOpenDetail(card) {
      this.$emit('open-detail', {
        item: card.item,
        source: 'warRoom',
        tabType: card.typeLabel === '经营简报' ? 'business' : 'news'
      })
    },
    handleOpenList() {
      this.$emit('open-list')
    },
    handleSmartAnalysis(card) {
      this.$emit('smart-analysis', {
        type: 'enterpriseWarRoom',
        content: card.desc || '请深度分析今日内部经营简报'
      })
    },
    toggleChatInput() {
      this.chatVisible = !this.chatVisible
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: 'rvc-cosmoplat-workspace-enterprise-war-room';
.#{$class-prefix} {
  .cards-row {
    display: flex;
    gap: 10px;
  }
  .card-type-tag {
    font-size: 11px;
    color: #4a5ff3;
    font-weight: 500;
    margin-bottom: 6px;
  }
  .card-tag {
    font-size: 12px;
    color: #4a5ff3;
    font-weight: 400;
    cursor: pointer;
    padding: 2px 8px;
  }
  .detail-tag {
    margin-right: 10px;
  }
 .card-content {
   display: flex;
   flex-direction: column;
   padding: 16px;
   border-radius: 8px;
   height: 138px;
   box-sizing: border-box;
   background: #ffffffb3;
   box-shadow: 0 0 8px 0 #005ddd29;
   flex: 1;
   min-width: 0;
 }
  .card-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 138px;
    font-size: 12px;
    color: #999;
    background: #ffffffb3;
    box-shadow: 0 0 8px 0 #005ddd29;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .content-section {
    flex: 1;
  }
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 13px;
  }
 .war-section-title {
   font-size: 14px;
   font-weight: 600;
   color: #333333;
   font-family: PingFangSC-Medium;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   width: 100%;
 }
 .esection-title {
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    font-family: PingFangSC-Medium;
  }
  .section-desc {
    font-size: 12px;
    color: #999;
    font-family: PingFangSC-Regular;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .action-buttons {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    // overflow: hidden;
    min-width: 0;
  }
  .btn-secondary {
    padding: 3px 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    color: #666666;
    font-size: 12px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 1 auto;
    min-width: 0;
    max-width: 50%;
  }
  .btn-primary {
    padding: 4px 14px;
    border: none;
    color: #fff;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s;
    font-family: PingFangSC-Regular;
    background-image: linear-gradient(270deg, #4a5ff3 0%, #4e86ff 100%);
    border-radius: 12px;
  }
}
.footer-btn {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
/* 提问按钮 */
.chat-tag {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  color: #4a5ff3 !important;
}
.chat-tag i {
  font-size: 13px;
}
/* 提问悬浮下拉框 */
.chat-dropdown {
  position: absolute;
  top: -15px;
  right: 55px;
  z-index: 1000;
  width: 460px;
  margin-top: 4px;
}
.chat-dropdown-inner {
  background: #fff;
  border: 1px solid #e8ecf0;
  border-radius: 16px;
  padding: 12px 14px 0;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.18);
}
.chat-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #333;
}
.chat-dropdown-header .el-icon-close {
  font-size: 15px;
  color: #999;
  cursor: pointer;
  padding: 2px;
}
.chat-dropdown-header .el-icon-close:hover {
  color: #333;
}
/* 过渡动画 */
.chat-fade-enter-active,
.chat-fade-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.chat-fade-enter,
.chat-fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
<style lang="scss">
/* ↓ 以下覆盖 CosmoClawInput 在下拉中的样式（不影响原来的）↓ */
.chat-dropdown-inner {
  .claw-input-wrapper {
    padding: 0 0 10px 0 !important;
  }
  .input-box {
    border: none !important;
    box-shadow: none !important;
    min-height: 90px;
    padding: 0 0 10px 0;
  }
  .input-box:focus-within {
    border: none !important;
    box-shadow: none !important;
  }
}
</style>
